<script>
    import "./permissionlessProject.css"
    import DetailPreview from "./detail-preview/DetailPreview.svelte";
    import PreviewTabs from "./preview-tabs/PreviewTabs.svelte";
</script>
<section class="preview-detail-wrapper flex flex-wrap">
    <DetailPreview/>
    <PreviewTabs/>
</section>